import React from 'react';

import DashboardLayout from '../layouts/Dashboard/Dashboard';

import MyDocuments from '../components/MyDocuments/MyDocuments';
import { statements, certificates, notifications } from '../components/Dashboard/testData';
import CustomerDataProvider from '../contexts/CustomerDataProvider';
import {setPageTitle} from '../utils/helpers';

const MyDocumentsPageContainer = () => {
  setPageTitle('My Documents | Investec Save');

  return (
    <CustomerDataProvider>
      <DashboardLayout notifications={notifications}>
        <MyDocuments statements={statements} certificates={certificates} />
      </DashboardLayout>
    </CustomerDataProvider>
  );

};

export default MyDocumentsPageContainer;
